export default "__VITE_PUBLIC_ASSET__a8c2af81__"